import { useStore } from '../context/store';

export default function useGetSeries() {
	const { dispatch } = useStore();

	const getSeries = async function () {
		// eslint-disable-next-line no-undef
		const url = `${WP.siteUrl}/wp-json/series-app/get-series`;

		dispatch({ type: 'setLoading', payload: true });

		const response = await fetch(url);
		const data = await response.json();

		dispatch({
			type: 'setSeries',
			payload: data,
		});

		dispatch({ type: 'setLoading', payload: false });
	};

	return {
		getSeries,
	};
}
